const contactLensOpticalParameters = new Set([
    'baseCurve',
    'diameter',
    'axis',
    'power',
    'cylinder',
    'addition', 
]);
const getContactLensSpecs = (attributes)=>attributes.filter((attribute)=>contactLensOpticalParameters.has(attribute.name)
    ).map(({ name , value  })=>({
            name,
            value
        })
    ) // filter out __typename
;
const TYPE_DETAILS_EYE_SIDE = {
    left: 'LEFT',
    right: 'RIGHT',
    both: 'BOTH'
};

export { TYPE_DETAILS_EYE_SIDE, getContactLensSpecs };
//# sourceMappingURL=get-contact-lens-specs.js.map
